// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3DydP","buttons":"Footer_buttons__tUT2X"};